import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
export const FIREBASE_CONFIG = {
    apiKey: process.env.MIX_FIREBASE_API_KEY,
    authDomain: process.env.MIX_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.MIX_FIREBASE_DB_URL,
    projectId: process.env.MIX_FIREBASE_PROJECT_ID,
    storageBucket: process.env.MIX_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.MIX_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.MIX_FIREBASE_APP_ID,
    measurementId: process.env.MIX_FIREBASE_MEASUREMENT_ID,
};
// 役割を分けるため以下をApp.jsに移行してください→長島
const firebaseApp = firebase.apps.length === 0
    ? firebase.initializeApp(FIREBASE_CONFIG, 'first')
    : firebase.initializeApp(FIREBASE_CONFIG, 'second');
export default firebaseApp;
